import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-eb9cd226")

_pushScopeId("data-v-eb9cd226")
const _hoisted_1 = { class: "flex flex-row gap-4 justify-between" }
const _hoisted_2 = { class: "metric-toggle-group pb-1 overflow-auto" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metricFilters, (filter) => {
        return (_openBlock(), _createBlock("button", {
          key: filter.key,
          class: ['metric-button', { active: _ctx.activeMetricFilter === filter.key }],
          onClick: ($event: any) => (_ctx.handleMetricChange(filter.key))
        }, _toDisplayString(_ctx.$t(filter.labelKey)), 11, ["onClick"]))
      }), 128))
    ])
  ]))
})